<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="title">
            {{ $t('add_filter') }}
          </span>
          <v-spacer />
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon v-on="on" @click="closeModal">
                <v-icon outline>
                  close
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
        </v-card-title>

        <v-divider />

        <v-card-text>
          <v-row no-gutters>
            <v-col cols="5">
              <v-text-field
                :autofocus="open"
                ref="name"
                :label="$t('name_user')"
                :hint="$t('key_name_user_hint')"
                v-model="name"
                counter
              />
            </v-col>
            <v-col cols="1" align-self="center">
              <v-row no-gutters>
                @
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :label="$t('ip')"
                :hint="$t('ip_hint')"
                v-model="ip"
                :error-messages="ipErrors"
                @input="$v.ip.$touch()"
                @blur="$v.ip.$touch()"
              />
            </v-col>
            <v-col>
              <v-row no-gutters justify="end">
                <v-btn
                  color="blue"
                  :disabled="$v.$invalid"
                  :dark="!$v.$invalid"
                  @click="submit"
                >
                  {{ $t('save') }}
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    open: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data () {
    return {
      dialog: this.open,
      ip: '',
      name: ''
    }
  },
  computed: {
    ipErrors () {
      const errors = []
      if (!this.$v.ip.$dirty) return errors
      !this.$v.ip.required && errors.push(this.$t('$validation.required'))
      !this.$v.ip.isValidIP && errors.push(this.$t('$validation.ip_not_valid'))
      return errors
    }
  },
  validations () {
    const validation = {}

    const isValidIP = value => {
      if (!value) return true

      const expression = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/

      const res = expression.test(value)
      return res
    }

    validation.ip = {
      required,
      isValidIP
    }
    return validation
  },
  methods: {
    closeModal () {
      this.dialog = false
      this.clear()
      this.$emit('close')
    },
    submit () {
      return this.addUserIP()
    },
    addUserIP () {
      // console.log('addUserIP')
      this.$store
        .dispatch('hsm/addIpFilter', {
          body: {
            usr: this.name,
            addr: this.ip
          }
        }) // RNM_ADD
        .then(() => {
          this.ip = ''

          this.$emit('success')
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    clear () {
      this.ip = null
      this.$v.$reset()
    },
    focusName () {
      this.$nextTick(this.$refs.name.focus)
    }
  },
  watch: {
    open (val) {
      this.dialog = val
      if (val) {
        // this.focusName()
      }
    }
  }
}
</script>
